import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./StudentAbsenteeismReportUIHelpers";

const StudentAbsenteeismReportUIContext = createContext();

export function useStudentAbsenteeismReportUIContext() {
  return useContext(StudentAbsenteeismReportUIContext);
}

export const StudentAbsenteeismReportUIConsumer = StudentAbsenteeismReportUIContext.Consumer;

export function StudentAbsenteeismReportUIProvider({ children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams
  };

  return (
    <StudentAbsenteeismReportUIContext.Provider value={value}>
      {children}
    </StudentAbsenteeismReportUIContext.Provider>
  );
}